<script setup>
const runtimeConfig = useRuntimeConfig()
const siteDescription = 'Compra tus boletos para eventos en línea en Tickea. Encuentra eventos de música, deportes, teatro y más en un solo lugar.'
const formatTitle = (titleChunk) => {
  return titleChunk
    ? `${titleChunk} | ${runtimeConfig.public.siteName}`
    : runtimeConfig.public.siteName;
};

useSeoMeta({
  titleTemplate: formatTitle,
  title: formatTitle,
  description: siteDescription,
  keywords: 'tickets, eventos, conciertos, deportes, teatro, boletos',
  image: `${runtimeConfig.public.siteUrl}/image.png`,
  url: runtimeConfig.public.siteUrl,
  type: 'website',
  site_name: runtimeConfig.public.siteName,
  ogTitle: formatTitle,
  applicationName: runtimeConfig.public.siteName,
  ogUrl: runtimeConfig.public.siteUrl,
  ogDescription: siteDescription,
  ogImage: `${runtimeConfig.public.siteUrl}/image.png`,
  creator: `${runtimeConfig.public.siteName} Platform, Inc.`,
  twitterTitle: formatTitle,
  twitterDescription: siteDescription,
  twitterImage: `${runtimeConfig.public.siteUrl}/image.png`,
  twitterCard: 'summary'
})
</script>

<template>
  <NuxtLoadingIndicator color="#E11B4C" :height="4" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
